import {createSlice} from '@reduxjs/toolkit';

export const pavFormSlice = createSlice({
    name: 'pavForm',
    initialState: {
        address: {
            address: {
                    properties: {
                }
            }
        },
        theme: 'grey',
        showPopup: false,
        suggestions: [],
        suggestionsOptions: [],
        displayControls: false,
        transactionCount: 0.0,
        searchFilters: [
            {
                'name': 'stateTerritory',
                'displayName': 'State / Territory',
                'label': 'All',
                'type': 'checkbox',
                'value': 'ALL',
                'enabled': true
            },
            {
                'name': 'stateTerritory',
                'label': 'ACT',
                'type': 'checkbox',
                'value': 'ACT',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'QLD',
                'type': 'checkbox',
                'value': 'QLD',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'NSW',
                'type': 'checkbox',
                'value': 'NSW',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'VIC',
                'type': 'checkbox',
                'value': 'VIC',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'TAS',
                'type': 'checkbox',
                'value': 'TAS',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'SA',
                'type': 'checkbox',
                'value': 'SA',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'NT',
                'type': 'checkbox',
                'value': 'NT',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'WA',
                'type': 'checkbox',
                'value': 'WA',
                'enabled': false
            },
            {
                'name': 'stateTerritory',
                'label': 'OT',
                'type': 'checkbox',
                'value': 'OT',
                'enabled': false
            },

            {
                'name': 'dataset',
                'displayName': 'Dataset',
                'label': 'All',
                'type': 'checkbox',
                'value': 'all',
                'enabled': true
            },
            {
                'name': 'dataset',
                'label': 'GNAF',
                'type': 'checkbox',
                'value': 'gnaf',
                'enabled': false
            },
            {
                'name': 'dataset',
                'label': 'GNAF Live',
                'type': 'checkbox',
                'value': 'gnaflive',
                'enabled': false
            },
            {
                'name': 'dataset',
                'label': 'Mail Address',
                'type': 'checkbox',
                'value': 'mailAddress',
                'enabled': false
            },

            {
                'name': 'addressType',
                'displayName': 'Address Type',
                'label': 'All',
                'type': 'checkbox',
                'value': 'all',
                'enabled': true
            },
            {
                'name': 'addressType',
                'label': 'Physical',
                'type': 'checkbox',
                'value': 'physical',
                'enabled': false
            },
            {
                'name': 'addressType',
                'label': 'Mailing',
                'type': 'checkbox',
                'value': 'mailing',
                'enabled': false
            },

            {
                'name': 'CrsAccept',
                'displayName': 'CRS',
                'label': 'GDA94',
                'type': 'radio',
                'value': '<https://www.opengis.net/def/crs/EPSG/0/4283>',
                'enabled': true
            },
            {
                'name': 'CrsAccept',
                'label': 'GDA2020',
                'type': 'radio',
                'value': '<https://www.opengis.net/def/crs/EPSG/0/7844>',
                'enabled': false
            },
            {
                'name': 'CrsAccept',
                'label': 'WGS84',
                'type': 'radio',
                'value': '<https://www.opengis.net/def/crs/EPSG/0/4326>',
                'enabled': false
            },
            {
                'name': 'CrsAccept',
                'label': 'AGD66',
                'type': 'radio',
                'value': '<https://www.opengis.net/def/crs/EPSG/0/4202>',
                'enabled': false
            },

            {
                'name': 'excludeAliases',
                'displayName': 'Aliases',
                'label': 'Exclude Aliases',
                'type': 'checkbox',
                'value': true,
                'enabled': false
            },

            {
                'name': 'maxNumberOfResults',
                'displayName': 'Maximum Number of Results',
                'label': 'Limit',
                'value': 5
            }

        ],
        addressResponseFormat: [
            {
                label: "INFO",
                enabled: true
            },
            {
                label: "JSON",
                enabled: false
            }
        ],
        fetchingSuggestions: false,
        fetchingAddress: false,
        fetchAddress: false,
        query: ''
    },
    reducers: {
        setFetchingSuggestions: (state, action) => {
            state.fetchingSuggestions = action.payload;
        },
        setFetchingAddress: (state, action) => {
            state.fetchingAddress = action.payload;
        },
        setFetchAddress: (state, action) => {
            state.fetchAddress = action.payload;
        },
        setSuggestions: (state, action) => {
            state.suggestions = action.payload;
            state.fetchingSuggestions = false;
            state.suggestionsOptions = action.payload.map((a) => ({
                rank: a.rank,
                id: a.id,
                address: a.address,
            }));
        },
        setAddress: (state, action) => {
            state.address = action.payload;
            state.fetchingAddress = false;
        },
        setShowPopup: (state, action) => {
            state.showPopup = action.payload;
        },
        setAddressView: (state) => {
            state.addressResponseFormat[0].enabled = !state.addressResponseFormat[0].enabled;
            state.addressResponseFormat[1].enabled = !state.addressResponseFormat[1].enabled;
        },
        setSearchFilters: (state, action) => {
            let options = state.searchFilters.filter(s => (
                s.name === action.payload.option.name
            ));
            if (action.payload.option.name === 'maxNumberOfResults') {
                options[0].value = action.payload.value
                return
            }
            let option = options.filter(s => (
                s.value === action.payload.option.value
            ))[0];
            if (option.type === 'radio') {
                let lastChecked = options.filter(s => (s.enabled))[0];
                lastChecked.enabled = !lastChecked.enabled;
                if (Object.keys(state.address).length) state.fetchAddress = true;
            }
            if (option.type === 'checkbox') {
                if (action.payload.option.label === 'All' && !action.payload.option.enabled) {
                    let otherOptions = options.filter(o => (o.label !== 'All'));
                    otherOptions.forEach(o => o.enabled = false);
                } else {
                    let all = options.filter(o => (o.label === 'All'));
                    if (all.length > 0 ) all[0].enabled = false;
                }
            }
            option.enabled = !option.enabled;
        },
        setTransactionCount: (state, action) => {
            state.transactionCount += action.payload;
        },
        resetTransactionCount: (state) => {
            state.transactionCount = 0;
        },
        setDisplayControls: (state) => {
            state.displayControls = !state.displayControls;
        },
        setQuery: (state, action) => {
            state.query = action.payload;
        },
        flipTheme: (state, action) => {
          if (state.theme === 'grey') {
              state.theme = 'black'
          }
          else if (state.theme === 'black') {
              state.theme = 'grey'
          }
          else {
              state.theme = 'grey'
          }
        }
    },
});

function getApiEndpoint() {
    // the endpoint that node could provide at buildtime, would be used for deployment builds
    const envEndpoint = process.env.REACT_APP_PAV_DEMO_ENDPOINT;
    // this endpoint will use whatever host react is served by
    const defaultEndpoint = '/v1/address';
    return (envEndpoint !== undefined ? envEndpoint : defaultEndpoint);
}

function filterToCSV(filters, name) {
    let csv = filters.filter(f => (
        f.name === name && f.enabled === true
    )).map(f => (f.value)).join();
    return csv.length ? csv : '';
}

export function getSuggestionUrlParams(searchFilters) {
    if (searchFilters === undefined || searchFilters.length === 0) {
        return '';
    }
    let stateTerritory = 'stateTerritory';
    let dataset = 'dataset';
    let addressType = 'addressType';
    let excludeAliases = 'excludeAliases';
    let maxNumberOfResults = 'maxNumberOfResults';
    let params = [];

    let stateTerritories = filterToCSV(searchFilters, stateTerritory);
    if (stateTerritories.length) params.push(`${stateTerritory}=${stateTerritories}`);

    let datasets = filterToCSV(searchFilters, dataset);
    if (datasets.length) params.push(`${dataset}=${datasets}`);

    let addressTypes = filterToCSV(searchFilters, addressType);
    if (addressTypes.length) params.push(`${addressType}=${addressTypes}`);

    let excludeAlias = searchFilters.filter(f => (
        f.name === excludeAliases
    ))[0];
    if (excludeAlias.enabled) params.push(`${excludeAliases}=${excludeAlias.value}`);

    let maxResults = searchFilters.filter(f => (f.name === maxNumberOfResults))[0]
    if (maxResults) maxResults = maxResults.value;
    if (maxResults) params.push(`${maxNumberOfResults}=${maxResults}`);

    return params.length ? '&' + params.join('&') : '';
}

export const getSuggestionAsync = (query, searchFilters) => dispatch => {
    const endpoint = getApiEndpoint();
    dispatch(setFetchingSuggestions(true));
    dispatch(setQuery(query));
    let params = getSuggestionUrlParams(searchFilters);
    let url = `${endpoint}?query=${query}${params}`;
    fetch(url)
        .then(res => {
            if (!res.ok) {
                throw new Error(':(');
            }
            dispatch(setTransactionCount(parseFloat(res.headers.get('x-attr-basictransaction'))));
            return res.json();
        })
        .then(json => dispatch(setSuggestions(json.suggest)))
        .catch(e => console.log(e));
    dispatch(setFetchingSuggestions(false));
};

export const getAddressAsync = (addressId, searchFilters) => dispatch => {
    dispatch(setFetchAddress(false));
    const endpoint = getApiEndpoint();
    dispatch(setFetchingAddress(true))
    let headers = {headers: {}, method: 'GET'};
    let crs = filterToCSV(searchFilters, 'CrsAccept');
    if (crs.length) headers.headers['Accept-Crs'] = crs;
    if (!addressId.length) return
    addressId = addressId[0].id;
    let url = `${endpoint}/${addressId}`;
    fetch(url, headers)
        .then(res => {
            if (!res.ok) {
                throw new Error(':(')
            }
            dispatch(setTransactionCount(parseFloat(res.headers.get('x-attr-basictransaction'))));
            return res.json()
        })
        .then(json => dispatch(setAddress(json)))
        .catch(e => console.log(e));
    dispatch(setFetchingAddress(false));
};

export const {
    reset,
    setAddress,
    setAddressView,
    setSuggestions,
    setFetchingSuggestions,
    setFetchingAddress,
    setFetchAddress,
    setQuery,
    setShowPopup,
    setSearchFilters,
    setTransactionCount,
    resetTransactionCount,
    flipTheme,
} = pavFormSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectAddress = state => state.pavForm.address;
export const selectShowPopup = state => state.pavForm.showPopup;
export const selectFetchingSuggestions = state => state.pavForm.fetchingSuggestions;
export const selectFetchingAddress = state => state.pavForm.fetchingAddress;
export const selectFetchAddress = state => state.pavForm.fetchAddress;
export const selectSuggestionsOptions = state => state.pavForm.suggestionsOptions;
export const selectSearchFilters = state => state.pavForm.searchFilters;
export const selectTransactionCount = state => state.pavForm.transactionCount;
export const selectDisplayControls = state => state.pavForm.displayControls;
export const selectAddressResponseFormat = state => state.pavForm.addressResponseFormat;
export const selectQuery = state => state.pavForm.query;
export const selectTheme = state => state.pavForm.theme;
export default pavFormSlice.reducer;
